export default class Physician {
  public static readonly PHYSICIAN_SEARCH = '/physicians';
  public static readonly GET_BALANCE = '/physician/{id}/balance';
  public static readonly GET_BALANCES = '/physician/balance';
  public static readonly PAYMENT_PAGE = '/physician/payment/page';
  public static readonly PHYSICIAN_LOOKUP = '/physician-lookup';
}
